import { useAppSelector } from '../..'
import { type IEnrollmentsList } from '../../../models/Enrollment'
import { type ISectionsList } from '../../../models/TermsSection'

export const getTermsSectionsList = (): ISectionsList | null => useAppSelector((state) => state.termsSections.termsSectionsList ?? [])
export const getEnrollmentList = (): IEnrollmentsList | null => useAppSelector((state) => state.termsSections.enrollmentList ?? [])
export const actionLoading = (): boolean => useAppSelector((state) => state.termsSections.actionLoading)
export const loading = (): boolean => useAppSelector((state) => state.termsSections.loading)
export const enrollmentsLoading = (): boolean => useAppSelector((state) => state.termsSections.enrollmentsLoading)
